<template>
    <div class="panel">
      <div class="panel-heading">
        <div class="panel-label">
          <h3> Shop Information </h3>
          <div class="checkbox">
            <label><input type="checkbox" v-model="data.enabled">Show shop in mobile app</label>
          </div>
        </div>
      </div>
      <div class="panel-body">
        <div class="alert alert-secondary">
            <div class="alert-text"> Base information</div>
        </div>
        <div class="row form-group ka-clean" v-if="getUser.role ==='admin'">
            <div class="col-3">
                <label class="input-label" v-bind:class="{required: isRequired('users')}">
                    Key account
                </label>
            </div>
            <div class="col-9">
                <key-account-picker :currentUser="currentUser" :validator="$v.shop.users" @changeUser="setKeyAccount" :editMode="true"></key-account-picker>
            </div>
        </div>
        <form-input :placeholder="$t('COMPANYDATA.shopName')"
                    :elementID="'shopName'"
                    :containerClass="'form-group'"
                    :inputClass="'form-control-sm'"
                    :validator="$v.shop.name"
                    :inputType="'text'"
                    :required="isRequired('name')"
                    v-model="shop.name">
        </form-input>
        <form-input :placeholder="`${$t('COMPANYDATA.iconUrl')} ( https )`"
                    :elementID="'iconURL'"
                    :containerClass="'form-group'"
                    :inputClass="'form-control-sm'"
                    :validator="$v.shop.iconURL"
                    :inputType="'text'"
                    :required="isRequired('iconURL')"
                    v-model="shop.iconURL">
        </form-input>

        <form-input :placeholder="$t('External ID')"
                    :elementID="'externalID'"
                    :containerClass="'form-group'"
                    :inputClass="'form-control-sm'"
                    :validator="$v.shop.externalID"
                    :inputType="'number'"
                    :required="isRequired('externalID')"
                    v-model="shop.externalID">
        </form-input>
        <form-input :placeholder="$t('Holder name')"
                    :elementID="'holderName'"
                    :containerClass="'form-group'"
                    :inputClass="'form-control-sm'"
                    :inputType="'text'"
                    v-model="shop.holderName">
        </form-input>
        <div class="col" v-if="!editMode || showLegals">
            <div class="row">
                <div class="col-3">
                    <label class="input-label legal">
                        {{$t('Additional legals')}}
                    </label>
                </div>
                <div class="col-6 legaltoggler">
                    <Toggler :value="shop.hasLegals" @input="hasLegalsChange"/>
                </div>
            </div>
        </div>
        <form-input v-if="editMode" :placeholder="$t('COMPANYDATA.setupId')"
                    :elementID="'setupId'"
                    :containerClass="'form-group'"
                    :inputClass="'form-control-sm'"
                    :validator="$v.shop.setupID"
                    :inputType="'text'"
                    v-model="shop.setupID"
                    :disabled="true">
        </form-input>
        <shop-address-data :validator="$v.shop.address" :data.sync="shop.address"/>
        <shop-workdays-data :data.sync="shop.workDays" />
          <br>
          <div>
              <div class="alert alert-secondary">
                  <div class="alert-text"> Pin code </div>
              </div>
              <div class="col">
                  <div class="row">
                      <div class="col-3">
                          <label for="pinCode" class="input-label">
                              Pin code
                          </label>
                      </div>
                      <div class="col-9">
                          <input type="checkbox" v-model="shop.pinCode" id="pinCode">
                      </div>
                  </div>
              </div>
          </div>
        <!-- <shop-documents-data :data.sync="shop.documents" :users.sync="shop.users" v-if="shop.documents" /> -->
      </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { required, url, between, maxLength  } from 'vuelidate/lib/validators';

import ShopWorkdaysData from './ShopWorkdaysData';
import ShopAddressData from './ShopAddressData';
import ShopDocumentsData from './ShopDocumentsData';
import FormInput from '../../../../Shared/UI/Form/FormInput.vue';
import Toggler from '../../../../Shared/Toggler.vue';
import KeyAccountPicker from '../../../../Shared/KeyAccountPicker/KeyAccountPicker';

export default {
    name: 'ShopRegistrationForm',
    props: {
        data: {
            type: Object
        },
        editMode: {
            type: Boolean,
            default: false,
        },
        touched: {
            type: Boolean,
            default: false,
        },
    },
    computed:{
        ...mapGetters({
            getUserChilds: 'getUserChilds',
            getUser: 'getUser',
            currentShop: 'currentShop'
        }),
        shop: {
            get() {
                return this.data;
            },
            // setter
            set(newValue){
                return this.data = newValue;
            }
      },
    },
    data() {
        return {
            currentUser: null,
            showLegals: false
        }
    },
    async created() {
        this.getKeyAccount(this.data);
        // await this.getDcoumentsAsync()
    },
    methods: {
        ...mapMutations([
            'setCurrentShopFormIsValidShopForm',
        ]),
        ...mapActions(['getDcoumentsAsync']),
        setKeyAccount(keyAccount) {
            this.currentUser = keyAccount;
            const id = keyAccount ? keyAccount.id : null;
            this.data.users = [{id}];
            this.$emit('keyaccountselected', id);
        },
        isRequired(inputType) {
            return this.$v.shop[inputType].$params.hasOwnProperty('required');
        },
        getKeyAccount(data) {
            let keyAccountId = data.users ? data.users[0].id : null;
            keyAccountId ? this.currentUser = this.getUserChilds.find(el => el.id === keyAccountId) : null;
        },
        hasLegalsChange(value){
            this.shop.hasLegals = value;
        }
    },
    components: {
        ShopWorkdaysData,
        ShopAddressData,
        FormInput,
        'key-account-picker': KeyAccountPicker,
        ShopDocumentsData,
        Toggler,
    },
    watch: {
        shop: {
            handler: function(newVal, oldVal) {
                this.showLegals = newVal.hasOwnProperty('hasLegals') ? true : false;
                if(newVal.name) {
                    this.getKeyAccount(newVal);
                } else {
                    this.currentUser = null;
                }
                this.setCurrentShopFormIsValidShopForm(!this.$v.shop.$invalid);
            },
            deep: true
        },
        touched(newVal, oldVal) {
            newVal ? this.$v.shop.$touch() : null;
        }
    },
    validations: {
        shop: {
            name: {
                required,
            },
            iconURL: {
                required,
                urlRegEx: (inputValue) => /^(https:\/\/www\.|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?.(jpg|png|svg|jpeg|gif)$/.test(inputValue),
            },
            users: {
                required,
            },
            externalID: {
                required
            },
            address: {
                street: {
                    required
                },
                houseNumber: {
                    required
                },
                postcode: {
                    required
                },
                city: {
                    required
                },
                country: {
                    required
                },
                latitude: {
                    required,
                    urlRegEx: (inputValue) => /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?)$/.test(inputValue),
                },
                longitude: {
                    required,
                    urlRegEx: (inputValue) => /^[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(inputValue),
                },
            },
        },
        // barcodeProduct: {
        //     maxLength: maxLength(5),
        //     urlRegEx: (inputValue) => /^[0-9]+$/.test(inputValue),
        // }
    }
};

</script>

<style lang="scss" scoped>
    form-input {
        & /deep/ .input-group input::-webkit-input-placeholder {
            color: lightgray;
        }
    }
    label {
        &.required{
            &:after { content: '*';color:red; }
        }
    }
    .ka-clean{
      margin-left: 0;
      margin-right: 0;
      label{
        line-height: 31px;
      }
      &.form-group{
        margin-bottom: 0;
      }
    }
    div.panel-label {
        width: 100%;
        justify-content: space-between;
    }
    label.legal{
        float: right;
        margin-bottom: 0;
        line-height: 2.5em;
    }
    .legaltoggler > * {
        padding-left: 0;
    }
</style>
